var Q = Object.defineProperty;
var z = (a) => {
  throw TypeError(a);
};
var W = (a, n, e) => n in a ? Q(a, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[n] = e;
var m = (a, n, e) => W(a, typeof n != "symbol" ? n + "" : n, e), E = (a, n, e) => n.has(a) || z("Cannot " + e);
var s = (a, n, e) => (E(a, n, "read from private field"), e ? e.call(a) : n.get(a)), p = (a, n, e) => n.has(a) ? z("Cannot add the same private member more than once") : n instanceof WeakSet ? n.add(a) : n.set(a, e), l = (a, n, e, t) => (E(a, n, "write to private field"), t ? t.call(a, e) : n.set(a, e), e), r = (a, n, e) => (E(a, n, "access private method"), e);
import { E as X, d as Z, x as ee, p as te, y as se, a as ie, J as ae, z as oe, Y as k, K as ne, M as C, T as j, O as re } from "./vidstack-8s6P_CC9.js";
const ue = /(?:youtu\.be|youtube|youtube\.com|youtube-nocookie\.com)(?:\/shorts)?\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|)((?:\w|-){11})/, Y = /* @__PURE__ */ new Map(), R = /* @__PURE__ */ new Map();
function B(a) {
  var n;
  return (n = a.match(ue)) == null ? void 0 : n[1];
}
async function de(a, n) {
  if (Y.has(a)) return Y.get(a);
  if (R.has(a)) return R.get(a);
  const e = new Promise(async (t) => {
    const u = ["maxresdefault", "sddefault", "hqdefault"];
    for (const d of u)
      for (const h of [!0, !1]) {
        const c = he(a, d, h);
        if ((await fetch(c, {
          mode: "no-cors",
          signal: n.signal
        })).status < 400) {
          Y.set(a, c), t(c);
          return;
        }
      }
  }).catch(() => "").finally(() => R.delete(a));
  return R.set(a, e), e;
}
function he(a, n, e) {
  return `https://i.ytimg.com/${e ? "vi_webp" : "vi"}/${a}/${n}.${e ? "webp" : "jpg"}`;
}
const me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  findYouTubePoster: de,
  resolveYouTubeVideoId: B
}, Symbol.toStringTag, { value: "Module" }));
var o, g, P, S, $, T, w, y, O, i, le, pe, F, U, b, I, J, N, D, V, q, K, L, M, A;
class ce extends X {
  constructor(e, t) {
    super(e);
    p(this, i);
    m(this, "$$PROVIDER_TYPE", "YOUTUBE");
    m(this, "scope", Z());
    p(this, o);
    p(this, g, ee(""));
    p(this, P, -1);
    p(this, S, null);
    p(this, $, null);
    p(this, T, -1);
    p(this, w, !1);
    p(this, y, /* @__PURE__ */ new Map());
    /**
     * Sets the player's interface language. The parameter value is an ISO 639-1 two-letter
     * language code or a fully specified locale. For example, fr and fr-ca are both valid values.
     * Other language input codes, such as IETF language tags (BCP 47) might also be handled properly.
     *
     * The interface language is used for tooltips in the player and also affects the default caption
     * track. Note that YouTube might select a different caption track language for a particular
     * user based on the user's individual language preferences and the availability of caption tracks.
     *
     * @defaultValue 'en'
     */
    m(this, "language", "en");
    m(this, "color", "red");
    /**
     * Whether cookies should be enabled on the embed. This is turned off by default to be
     * GDPR-compliant.
     *
     * @defaultValue `false`
     */
    m(this, "cookies", !1);
    /**
     * Whether the embed should use YouTube Education. This is turned off by default.
     *
     * @defaultValue `false`
     */
    m(this, "education", !1);
    /**
     * Whether the YouTube captions should be auto loaded
     */
    m(this, "autoLoadCaptions", !1);
    /**
     * The encrypted payload to use for the embed. This is mandatory for YouTube Education
     * to work as expected.
     *
     * @defaultValue `undefined`
     */
    p(this, O);
    l(this, o, t);
  }
  /**
   * Set the encrypted payload to use for the embed. It must be encrypted according to YouTube dev guide.
   * This is mandatory for YouTube Education to work as expected.
   *
   * @defaultValue `undefined`
   */
  set encryptedPayload(e) {
    l(this, O, e);
  }
  get currentSrc() {
    return s(this, S);
  }
  get type() {
    return "youtube";
  }
  get videoId() {
    return s(this, g).call(this);
  }
  preconnect() {
    te(this.getOrigin());
  }
  setup() {
    super.setup(), se(r(this, i, F).bind(this)), s(this, o).notify("provider-setup", this);
  }
  destroy() {
    r(this, i, L).call(this);
    const e = "provider destroyed";
    for (const t of s(this, y).values())
      for (const { reject: u } of t) u(e);
    s(this, y).clear();
  }
  async play() {
    return r(this, i, b).call(this, "playVideo");
  }
  async pause() {
    return r(this, i, b).call(this, "pauseVideo");
  }
  setMuted(e) {
    e ? r(this, i, b).call(this, "mute") : r(this, i, b).call(this, "unMute");
  }
  setCurrentTime(e) {
    r(this, i, b).call(this, "seekTo", e), s(this, o).notify("seeking", e);
  }
  setVolume(e) {
    r(this, i, b).call(this, "setVolume", e * 100);
  }
  setPlaybackRate(e) {
    r(this, i, b).call(this, "setPlaybackRate", e);
  }
  async loadSource(e) {
    if (!ie(e.src)) {
      l(this, S, null), s(this, g).set("");
      return;
    }
    const t = B(e.src);
    s(this, g).set(t ?? ""), l(this, S, e);
  }
  getOrigin() {
    switch (!0) {
      case this.education:
        return "https://www.youtubeeducation.com";
      case this.cookies:
        return "https://www.youtube.com";
      default:
        return "https://www.youtube-nocookie.com";
    }
  }
  buildParams() {
    const { keyDisabled: e } = s(this, o).$props, { muted: t, playsInline: u, nativeControls: d } = s(this, o).$state, h = d();
    return {
      rel: 0,
      autoplay: 0,
      color: this.color,
      cc_load_policy: this.autoLoadCaptions ? 1 : void 0,
      controls: h ? 1 : 0,
      disablekb: !h || e() ? 1 : 0,
      enablejsapi: 1,
      fs: 1,
      hl: this.language,
      iv_load_policy: h ? 1 : 3,
      mute: t() ? 1 : 0,
      playsinline: u() ? 1 : 0,
      videoId: s(this, g).call(this),
      embed_config: r(this, i, U).call(this)
    };
  }
  onLoad() {
    window.setTimeout(() => this.postMessage({ event: "listening" }), 100);
  }
  onMessage({ info: e }, t) {
    var c, _;
    if (!e) return;
    const { title: u, intrinsicDuration: d, playbackRate: h } = s(this, o).$state;
    if (ne(e.videoData) && e.videoData.title !== u() && s(this, o).notify("title-change", e.videoData.title, t), (c = e.namespaces) != null && c.includes("captions") && e.captions && s(this, $) === null && (l(this, $, [...e.captions.tracklist, e.captions.track]), s(this, o).notify("loaded-metadata", {
      youtubeCaptions: s(this, $)
    })), C(e.duration) && e.duration !== d()) {
      if (C(e.videoLoadedFraction)) {
        const f = ((_ = e.progressState) == null ? void 0 : _.loaded) ?? e.videoLoadedFraction * e.duration, v = new j(0, e.duration);
        r(this, i, D).call(this, f, v, t);
      }
      s(this, o).notify("duration-change", e.duration, t);
    }
    if (C(e.playbackRate) && e.playbackRate !== h() && s(this, o).notify("rate-change", e.playbackRate, t), e.progressState) {
      const { current: f, seekableStart: v, seekableEnd: G, loaded: H, duration: x } = e.progressState;
      r(this, i, N).call(this, f, t), r(this, i, D).call(this, H, new j(v, G), t), x !== d() && s(this, o).notify("duration-change", x, t);
    }
    if (C(e.volume) && re(e.muted) && !s(this, w)) {
      const f = {
        muted: e.muted,
        volume: e.volume / 100
      };
      s(this, o).notify("volume-change", f, t);
    }
    C(e.playerState) && e.playerState !== s(this, P) && r(this, i, K).call(this, e.playerState, t);
  }
}
o = new WeakMap(), g = new WeakMap(), P = new WeakMap(), S = new WeakMap(), $ = new WeakMap(), T = new WeakMap(), w = new WeakMap(), y = new WeakMap(), O = new WeakMap(), i = new WeakSet(), le = function(e) {
  var t;
  (t = r(this, i, M).call(this, "playVideo")) == null || t.reject(e);
}, pe = function(e) {
  var t;
  (t = r(this, i, M).call(this, "pauseVideo")) == null || t.reject(e);
}, F = function() {
  r(this, i, L).call(this);
  const e = s(this, g).call(this);
  if (!e) {
    this.src.set("");
    return;
  }
  this.src.set(`${this.getOrigin()}/embed/${e}`), s(this, o).notify("load-start");
}, U = function() {
  const e = s(this, O);
  if (!ae(e))
    return JSON.stringify({ enc: e, hideTitle: !0 });
}, b = function(e, t) {
  let u = oe(), d = s(this, y).get(e);
  return d || s(this, y).set(e, d = []), d.push(u), this.postMessage({
    event: "command",
    func: e,
    args: t ? [t] : void 0
  }), u.promise;
}, I = function(e) {
  s(this, o).notify("loaded-data"), s(this, o).delegate.ready(void 0, e);
}, J = function(e) {
  var t;
  (t = r(this, i, M).call(this, "pauseVideo")) == null || t.resolve(), s(this, o).notify("pause", void 0, e);
}, N = function(e, t) {
  const { duration: u, realCurrentTime: d } = s(this, o).$state, h = s(this, P) === k.Ended, c = h ? u() : e;
  s(this, o).notify("time-change", c, t), !h && Math.abs(c - d()) > 1 && s(this, o).notify("seeking", c, t);
}, D = function(e, t, u) {
  const d = {
    buffered: new j(0, e),
    seekable: t
  };
  s(this, o).notify("progress", d, u);
  const { seeking: h, realCurrentTime: c } = s(this, o).$state;
  h() && e > c() && r(this, i, V).call(this, u);
}, V = function(e) {
  const { paused: t, realCurrentTime: u } = s(this, o).$state;
  window.clearTimeout(s(this, T)), l(this, T, window.setTimeout(
    () => {
      s(this, o).notify("seeked", u(), e), l(this, T, -1);
    },
    t() ? 100 : 0
  ));
}, q = function(e) {
  const { seeking: t } = s(this, o).$state;
  t() && r(this, i, V).call(this, e), s(this, o).notify("pause", void 0, e), s(this, o).notify("end", void 0, e);
}, K = function(e, t) {
  var v;
  const { paused: u, seeking: d } = s(this, o).$state, h = e === k.Playing, c = e === k.Buffering, _ = r(this, i, A).call(this, "playVideo"), f = u() && (c || h);
  if (c && s(this, o).notify("waiting", void 0, t), d() && h && r(this, i, V).call(this, t), s(this, w) && h) {
    this.pause(), l(this, w, !1), this.setMuted(s(this, o).$state.muted());
    return;
  }
  if (!_ && f) {
    l(this, w, !0), this.setMuted(!0);
    return;
  }
  switch (f && ((v = r(this, i, M).call(this, "playVideo")) == null || v.resolve(), s(this, o).notify("play", void 0, t)), e) {
    case k.Cued:
      r(this, i, I).call(this, t);
      break;
    case k.Playing:
      s(this, o).notify("playing", void 0, t);
      break;
    case k.Paused:
      r(this, i, J).call(this, t);
      break;
    case k.Ended:
      r(this, i, q).call(this, t);
      break;
  }
  l(this, P, e);
}, L = function() {
  l(this, P, -1), l(this, T, -1), l(this, w, !1);
}, M = function(e) {
  var t;
  return (t = s(this, y).get(e)) == null ? void 0 : t.shift();
}, A = function(e) {
  var t;
  return !!((t = s(this, y).get(e)) != null && t.length);
};
const be = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  YouTubeProvider: ce
}, Symbol.toStringTag, { value: "Module" }));
export {
  be as p,
  me as u
};
